/* eslint-disable lingui/text-restrictions */

import { t } from "@lingui/macro";

import { axios } from "@/client/libs/axios";
import { pollAIResult } from "../ai/poll";

export const fixGrammar = async (text: string) => {
  const result = await axios.post<{ key: string }>("/ai/fix-grammar", {
    data: text,
  });
  const fixedText = await pollAIResult<string>(result.data.key);
  if (!fixedText) {
    throw new Error(t`The server did not return fixed text for your input.`);
  }

  return fixedText;
};
